package io.horion.cv.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.SubscribeButtonStyle
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.*


@Composable
fun PaymentFailedPopup(
    message: String,
    onDismiss: () -> Unit = {},
    onRetry: (() -> Unit)? = null
) {

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val pageBg     = if (isDark) Colors.DarkBG   else Colors.White
    val titleColor = if (isDark) Colors.White     else Colors.NightBlue
    val iconFilter = if (isDark) "none"           else "invert(0.8)"

    // Overlay est le composant Kobweb idéal pour les popups/modals
    Overlay(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(Color.rgba(0, 0, 0, 0.6f))
            .onClick { onDismiss() },
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .width(380.px)
                .backgroundColor(pageBg)
                .borderRadius(20.px)
                .padding(24.px)
                .onClick { it.stopPropagation() } // Empêche la fermeture au clic interne
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                // Icône d'erreur (Cercle rouge avec X)
                Box(
                    modifier = Modifier
                        .size(72.px)
                        .backgroundColor(Color.rgba(255, 77, 79, 0.2f))
                        .borderRadius(50.percent),
                    contentAlignment = Alignment.Center
                ) {
                    SpanText(
                        "✕",
                        modifier = Modifier
                            .color(Color.rgb(0xFF, 0x4D, 0x4F))
                            .fontSize(32.px)
                            .fontWeight(FontWeight.Bold)
                    )
                }

                Box(modifier = Modifier.height(8.px))

                SpanText(
                    "Paiement échoué",
                    modifier = Modifier
                        .fontSize(22.px)
                        .fontWeight(FontWeight.Bold)
                        .color(titleColor)
                )

                Box(modifier = Modifier.height(8.px))

                SpanText(
                    message,
                    modifier = Modifier
                        .fontSize(15.px)
                        .color(titleColor)
                        .textAlign(TextAlign.Center)
                )

                Box(modifier = Modifier.height(8.px))

                // Boutons d'action
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.Center
                ) {
                    Button(
                        onClick = { onDismiss() },
                        modifier = SubscribeButtonStyle.toModifier()
                            .margin(right = 12.px)
                            //.padding(topBottom = 10.px, leftRight = 20.px)
                            .fontWeight(FontWeight.Medium)
                            .borderRadius(30.px)
                            .color(Colors.White)
                    ) {
                        SpanText("Fermer")
                    }

                    if (onRetry != null) {
                        Button(
                            onClick = { onRetry() },
                            modifier = SubscribeButtonStyle.toModifier()
                                .padding(topBottom = 10.px, leftRight = 20.px)
                                .fontWeight(FontWeight.Medium)
                                .borderRadius(30.px)
                                .color(Colors.White)

                        ) {
                            SpanText("Réessayer", modifier = Modifier.color(Colors.White))
                        }
                    }
                }
            }
        }
    }
}